import {keyframes as stylexKeyframes} from '@stylexjs/stylex';
import {createKeyframes} from '../style/createKeyframes';

// Enforcing the more restrictive typing of stylex `keyframes()` allows us
// to catch usages of `createKeyframes()` that are not compatible with stylex.
export function keyframes(...args: Parameters<typeof stylexKeyframes>) {
  if (
    typeof DISABLE_SAIL_RUNTIME_CSS !== 'undefined' &&
    DISABLE_SAIL_RUNTIME_CSS
  ) {
    return stylexKeyframes(...args);
  }

  return createKeyframes(...(args as Parameters<typeof createKeyframes>));
}
